// GLOBAL VARIABLE SETUP
// =================================================================================================
// COMPONENTS
import React from 'react';

// HELP FUNCTIONS
import '../../utils/canvas-to-blob';
import '../../utils/kawo-tooltip';
import '../../styles/home.css';

// COMPONENT SPECIFIC IMAGES
import logo from '../../icon.png';
import logo2x from '../../icon@2x.png';

import _ from 'underscore';
import feather from '../../../node_modules/feather-icons/dist/feather.js';


// MAIN REACT CLASS DECLARATION
// =================================================================================================
class Home extends React.Component {


	// REACT APP CONSTRUCTOR
	// =============================================================================================
	constructor( props ) {

		super( props );

		this.state = {
			inBounds: false
		};

		// TODO: PULL PROJECTS OUT OF LOCALSTORAGE

		window.trackEvent( 'Pageview', {
			view: 'Home'
		});
	}


	// MAIN RENDER METHOD
	// =============================================================================================
	render() {

		let $this = this,
			create;

		if ( !this.state.createNew ) create =
			<div className="create-project" onClick={ ( e ) => this.createNew( e ) }>
				<p>Create new project</p>
				<i className="icon icon_large" dangerouslySetInnerHTML={ { __html: feather.icons[ 'arrow-right-circle' ].toSvg({ width: 44, height: 44, 'stroke-width': 1 }) } } />
			</div>;

		else create =
			<div className="create-project create-project_active">
				<input data-project-name={ this.state.projectName } className="input fn-project-name" type="text"
					   onChange={ ( e ) => this.setProjectName( e ) }
					   onKeyDown={ ( e ) => this.setProjectName( e ) } />
				<i data-project-name={ this.state.projectName } onClick={ ( e ) => this.createProject( e ) } className="icon icon_large" dangerouslySetInnerHTML={ { __html: feather.icons[ 'arrow-right-circle' ].toSvg({ width: 44, height: 44, 'stroke-width': 1 }) } } />
			</div>;

		let localStorageList = JSON.parse( localStorage.getItem( 'projects' ) );

		return <div className="app-container">

			<header className="header">
				<div>
					<a href="https://subtitle.studio" className="logo"><img src={ window.devicePixelRatio >= 2 ? logo2x : logo } /></a>
				</div>
			</header>

			<div className="home-container">

				{ create }

				{
					// IF WE HAVE PROJECTS IN LOCALSTORAGE › DISPLAY THEM
					localStorageList ?

					<ul className="localstorage-list">
						{
							_.map( localStorageList, function( project, projectId ) {

								return <li key={projectId} data-project-name={projectId} onClick={ ( e ) => $this.selectProject( e ) }
										   className="localstorage-list__item"><p>{ project.projectName }</p></li>;
							})
						}
					</ul>

					// SHOW DISABLED PLACEHOLDER LIST
				:

					<ul className="localstorage-list localstorage-list_disabled">
						<li className="localstorage-list__item"><p>You can access your projects here once you create one...</p></li>
					</ul>
				}
			</div>
		</div>
	}


	// =============================================================================================
	createNew() {

		this.setState( prevState => ({
			createNew: true
		}), () => {

			window.trackEvent( 'Projects', {
				action: 'create-new'
			});
		});

		setTimeout( function() {
			if ( document.querySelector( '.fn-project-name' ) ) document.querySelector( '.fn-project-name' ).focus();
		}, 16 );
	}


	// =============================================================================================
	setProjectName( e ) {

		if ( e.keyCode === 13 ) {

			this.createProject( e );

			return;
		}

		e.persist();

		this.setState( prevState => ({
			projectName: e.target.value
		}) );
	}


	// =============================================================================================
	createProject( e ) {

		e.persist();

		if ( !e.target.dataset.projectName ) return;

		let projects = JSON.parse( localStorage.getItem( 'projects' ) ) || {},
			projectId = e.target.dataset.projectName && e.target.dataset.projectName.replace( /\s/g, '-' ).toLowerCase();

		// TODO: DISPLAY ERROR THAT A PROJECT WITH THAT NAME EXISTS
		if ( projects[ projectId ] ) return;

		// SET STATE ON PARENT TO MOVE TO EDITOR LAYER
		this.props.app.setState( prevState => ({
			projectName: e.target.dataset.projectName,
			view: 'upload'
		}) );

		window.trackEvent( 'Projects', {
			action: 'create-project',
			new: this.state.createNew,
			projectName: e.target.dataset.projectName
		});
	}


	// =============================================================================================
	selectProject( e ) {

		e.persist();

		let projects = JSON.parse( localStorage.getItem( 'projects' ) ) || {},
			projectId = e.currentTarget.dataset.projectName && e.currentTarget.dataset.projectName.replace( /\s/g, '-' ).toLowerCase();

		// TODO: PROPER ERROR HANDLING
		if ( !projects[ projectId ] ) alert( 'We couldn\'t find this project for some crazy reason' );

		window.localProject = projects[ projectId ];

		// SEND THEM TO UPLOAD VIEW
		this.props.app.setState( prevState => ({
			projectName: window.localProject.projectName,
			view: 'upload'
		}) );

		window.trackEvent( 'Projects', {
			action: 'select-project',
			projectName: window.localProject.projectName,
			projectId: projectId
		});
	}
}

export default Home;


// WEBPACK FOOTER //
// ./src/scenes/Home/index.js